import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { routes } from './app.routes'; // Importa las rutas

@NgModule({
  imports: [RouterModule.forRoot(routes/*, { useHash: true}*/)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
